import { styled } from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex-direction: column;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  opacity: 60%;
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }

  &:hover {
    opacity: 100%;
  }
`;
